import { render, staticRenderFns } from "./TextSearch.vue?vue&type=template&id=55208783&"
import script from "./TextSearch.vue?vue&type=script&lang=js&"
export * from "./TextSearch.vue?vue&type=script&lang=js&"
import style0 from "./TextSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports